import { c as _c } from "react/compiler-runtime";
import upperCase from 'lodash/upperCase';
import upperFirst from 'lodash/upperFirst';
import { useTranslation } from 'react-i18next';
import type { CameraErrorCause, ReceivedImagePayload } from '../../../types';
import useDocName from '../../hooks/use-doc-name';
import useIdDocMachine from '../../hooks/use-id-doc-machine';
import BackPhotoCaptureView from './back-photo-capture-view';
const BackPhotoCapture = () => {
  const $ = _c(35);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "document-flow.id-doc.pages.back-photo-capture"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t0);
  const [state, dispatch] = useIdDocMachine();
  const {
    idDoc: t1,
    requirement,
    hasBadConnectivity,
    allowPdf
  } = state.context;
  const {
    type: docType
  } = t1;
  let t2;
  if ($[1] !== docType) {
    t2 = {
      docType,
      imageType: "back"
    };
    $[1] = docType;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    getDocName,
    getSideName
  } = useDocName(t2);
  if (!docType) {
    return null;
  }
  let docName;
  let t3;
  if ($[3] !== getDocName) {
    docName = getDocName();
    t3 = upperFirst(docName);
    $[3] = getDocName;
    $[4] = docName;
    $[5] = t3;
  } else {
    docName = $[4];
    t3 = $[5];
  }
  const docNameCapitalized = t3;
  let sideName;
  let t4;
  if ($[6] !== getSideName) {
    sideName = getSideName();
    t4 = upperCase(sideName);
    $[6] = getSideName;
    $[7] = sideName;
    $[8] = t4;
  } else {
    sideName = $[7];
    t4 = $[8];
  }
  const sideNameCapitalized = t4;
  let t5;
  if ($[9] !== dispatch) {
    t5 = payload => dispatch({
      type: "receivedImage",
      payload
    });
    $[9] = dispatch;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const onComplete = t5;
  let t6;
  if ($[11] !== dispatch) {
    t6 = () => dispatch({
      type: "navigatedToPrev"
    });
    $[11] = dispatch;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const handleClickBack = t6;
  let t7;
  if ($[13] !== dispatch) {
    t7 = () => dispatch({
      type: "cameraStuck"
    });
    $[13] = dispatch;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const handleCameraStuck = t7;
  let t8;
  if ($[15] !== dispatch) {
    t8 = cause => dispatch({
      type: "cameraErrored",
      payload: {
        cause
      }
    });
    $[15] = dispatch;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const handleCameraErrored = t8;
  let t9;
  if ($[17] !== dispatch) {
    t9 = () => dispatch({
      type: "cameraAccessDenied",
      payload: {
        status: "denied"
      }
    });
    $[17] = dispatch;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const handleCameraAccessDenied = t9;
  const t10 = `${docNameCapitalized} · ${sideNameCapitalized}`;
  let t11;
  if ($[19] !== t) {
    t11 = t(_temp);
    $[19] = t;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== allowPdf || $[22] !== docName || $[23] !== docNameCapitalized || $[24] !== handleCameraAccessDenied || $[25] !== handleCameraErrored || $[26] !== handleCameraStuck || $[27] !== handleClickBack || $[28] !== hasBadConnectivity || $[29] !== onComplete || $[30] !== requirement || $[31] !== sideName || $[32] !== t10 || $[33] !== t11) {
    t12 = <BackPhotoCaptureView docName={docName} sideName={sideName} cameraTitle={t10} previewTitle={docNameCapitalized} previewSubtitle={t11} requirement={requirement} hasBadConnectivity={hasBadConnectivity} allowPdf={allowPdf} onComplete={onComplete} onBack={handleClickBack} onCameraStuck={handleCameraStuck} onCameraErrored={handleCameraErrored} onCameraAccessDenied={handleCameraAccessDenied} />;
    $[21] = allowPdf;
    $[22] = docName;
    $[23] = docNameCapitalized;
    $[24] = handleCameraAccessDenied;
    $[25] = handleCameraErrored;
    $[26] = handleCameraStuck;
    $[27] = handleClickBack;
    $[28] = hasBadConnectivity;
    $[29] = onComplete;
    $[30] = requirement;
    $[31] = sideName;
    $[32] = t10;
    $[33] = t11;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  return t12;
};
export default BackPhotoCapture;
function _temp($) {
  return $.subtitle.preview;
}